var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0l3.934 9.059L28 9.907l-7.63 6.473L22.652 26 14 20.896 5.348 26l2.296-9.62L0 9.907l10.066-.834L14 0zm2.575 10.952l-2.573-5.929-2.577 5.944-6.447.534 4.897 4.147-1.488 6.237L14 18.574l5.622 3.316-1.481-6.242 4.895-4.153-6.46-.543z",
    fillRule: "nonzero"
  })));
};
export default SvgStar;